class AlphabeticalGrid extends HTMLElement {
  connectedCallback() {
    if (!window.alphabeticItems || !Array.isArray(window.alphabeticItems)) {
      return;
    }

    const sortedItems = window.alphabeticItems.sort((a, b) => {
      const titleA = (a.title || '').trim().toUpperCase();
      const titleB = (b.title || '').trim().toUpperCase();
      return titleA.localeCompare(titleB);
    });

    const groupedItems = {};
    sortedItems.forEach(item => {
      const firstLetter = (item.title || '').trim().charAt(0).toUpperCase();
      if (!firstLetter || !/[A-Z]/.test(firstLetter)) {
        const key = '#';
        if (!groupedItems[key]) {
          groupedItems[key] = [];
        }
        groupedItems[key].push(item);
      } else {
        if (!groupedItems[firstLetter]) {
          groupedItems[firstLetter] = [];
        }
        groupedItems[firstLetter].push(item);
      }
    });

    const gridWrapper = document.createElement('div');
    gridWrapper.className = 'alphabetic-grid';

    const sortedLetters = Object.keys(groupedItems).sort((a, b) => {
      if (a === '#') return -1;
      if (b === '#') return 1;
      return a.localeCompare(b);
    });

    sortedLetters.forEach(letter => {
      const section = document.createElement('div');
      section.className = 'letter-section';
      section.id = `letter-${letter === '#' ? '0-9' : letter.toLowerCase()}`;

      const header = document.createElement('h2');
      header.className = 'letter-header header-m';
      header.textContent = letter === '#' ? '0-9' : letter;
      section.appendChild(header);

      const grid = document.createElement('div');
      grid.className = 'items-grid';

      groupedItems[letter].forEach(item => {
        const gridItem = document.createElement('div');
        gridItem.className = 'grid-item';

        const link = document.createElement('a');
        link.href = item.url || '#';
        link.textContent = item.title || '';

        const title = document.createElement('div');
        title.className = 'grid-item-title';
        title.appendChild(link);

        gridItem.appendChild(title);
        grid.appendChild(gridItem);
      });

      section.appendChild(grid);
      gridWrapper.appendChild(section);
    });

    this.appendChild(gridWrapper);

    this.createNavigation(sortedLetters);
  }

  createNavigation(availableLetters) {
    const navContainer = document.createElement('div');
    navContainer.className = 'alphabetic-navigation';

    const navList = document.createElement('div');
    navList.className = 'alphabetic-navigation-list';

    const allLetters = ['#', ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))];

    allLetters.forEach(letter => {
      const link = document.createElement('a');
      const displayText = letter === '#' ? '0-9' : letter;
      const anchorId = `letter-${letter === '#' ? '0-9' : letter.toLowerCase()}`;

      if (availableLetters.includes(letter)) {
        link.href = `#${anchorId}`;
        link.textContent = displayText;
        link.className = 'alphabetic-nav-link';
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const target = document.getElementById(anchorId);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      } else {
        link.textContent = displayText;
        link.className = 'alphabetic-nav-link alphabetic-nav-link--disabled';
        link.setAttribute('aria-disabled', 'true');
      }

      navList.appendChild(link);
    });

    navContainer.appendChild(navList);

    const container = this.parentElement;
    if (container) {
      const heading = container.querySelector('.header-l');
      if (heading) {
        container.insertBefore(navContainer, this);
      } else {
        container.insertBefore(navContainer, container.firstChild);
      }
    }
  }
}

customElements.define('alphabetical-grid', AlphabeticalGrid);
